import React from "react";
import { Users } from "lucide-react";
import { Field, inputCls, cardCls } from "./FormBits";
import { ReferralField } from "../ReferralField";

const CONSENTS = [
  ["guardian_confirm", "I confirm I am the participant's parent or authorized legal guardian."],
  ["terms", "I accept the camp's registration terms and conditions."],
  ["privacy", "I acknowledge the privacy policy and processing of personal information necessary for registration."],
  ["medical_share", "I acknowledge that relevant injury, allergy, and medical information may be shared with authorized camp staff for participant safety."],
];

function GuardianDetails({ guardian, setG }) {
  return (
    <div className={cardCls}>
      <div className="flex items-center gap-2 font-display font-bold text-lg text-[#03281B] mb-4"><Users size={20} className="text-[#008057]" /> Parent / Legal Guardian</div>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="First name" required><input data-testid="input-guardian-name" className={inputCls} value={guardian.first_name} onChange={(e) => setG({ first_name: e.target.value })} /></Field>
        <Field label="Last name" required><input data-testid="input-guardian-lastname" className={inputCls} value={guardian.last_name} onChange={(e) => setG({ last_name: e.target.value })} /></Field>
        <Field label="Email address" required><input data-testid="input-guardian-email" type="email" className={inputCls} value={guardian.email} onChange={(e) => setG({ email: e.target.value })} /></Field>
        <Field label="Mobile phone" required><input data-testid="input-guardian-phone" className={inputCls} value={guardian.phone} onChange={(e) => setG({ phone: e.target.value })} placeholder="+1 555 123 4567" /></Field>
        <Field label="Country of residence"><input className={inputCls} value={guardian.country} onChange={(e) => setG({ country: e.target.value })} /></Field>
      </div>
    </div>
  );
}

function GiftRecipient({ participants, value, onChange }) {
  return (
    <div className="rounded-2xl bg-amber-50 border-2 border-[#F3C242] p-6">
      <div className="font-bold text-[#03281B] mb-2">Jersey Gift Recipient</div>
      <p className="text-sm text-slate-600 mb-3">If your registration qualifies for the retro Cristiano Ronaldo jersey (first 5, confirmed payment), which participant should receive it?</p>
      <select data-testid="gift-recipient-select" className={inputCls} value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {participants.map((p, i) => <option key={p._k} value={i}>{p.first_name} {p.last_name}</option>)}
      </select>
    </div>
  );
}

function Consents({ consents, setConsents, guardian, setG }) {
  return (
    <div className={cardCls}>
      <div className="font-display font-bold text-lg text-[#03281B] mb-4">Consent & Privacy</div>
      <div className="space-y-3">
        {CONSENTS.map(([k, label]) => (
          <label key={k} data-testid={`consent-${k}`} className="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" className="accent-[#008057] w-5 h-5 mt-0.5" checked={consents[k]} onChange={(e) => setConsents({ ...consents, [k]: e.target.checked })} />
            <span className="text-sm text-slate-700">{label} <span className="text-red-500">*</span></span>
          </label>
        ))}
        <label className="flex items-start gap-3 cursor-pointer border-t border-slate-100 pt-3">
          <input type="checkbox" className="accent-[#008057] w-5 h-5 mt-0.5" checked={guardian.marketing_consent} onChange={(e) => setG({ marketing_consent: e.target.checked })} />
          <span className="text-sm text-slate-700">I would like to receive occasional marketing updates (optional).</span>
        </label>
      </div>
    </div>
  );
}

export function GuardianStep({ guardian, setGuardian, consents, setConsents, participants, showGift, giftRecipientIndex, setGiftRecipientIndex }) {
  const setG = (patch) => setGuardian({ ...guardian, ...patch });
  return (
    <div data-testid="step-2-guardian-form" className="space-y-6">
      <GuardianDetails guardian={guardian} setG={setG} />
      <ReferralField inputCls={inputCls} value={guardian.referral_code} partner={guardian.referral_partner}
        onChange={(v) => setG({ referral_code: v, referral_partner: "" })} />
      {showGift && <GiftRecipient participants={participants} value={giftRecipientIndex} onChange={setGiftRecipientIndex} />}
      <Consents consents={consents} setConsents={setConsents} guardian={guardian} setG={setG} />
    </div>
  );
}
